export default {
    fields:[
        {
            key: "queryName",
            label:"name",
            sorter: false,
            filter: false,
        },
        {
            key: "queryValue",
            label:"value",
            sorter: false,
            filter: false,
        },
        {
            key: "queryMethod",
            label:"method",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label:"options",
            sorter: false,
            filter: false, 
            _style: 'width:10%',
            _classes: "text-center"
        },
    ],
    items:[]
}